import { CognitoJwtVerifier } from "aws-jwt-verify";

/**
 * Service for AWS Cognito authentication operations
 */
class CognitoService {
  constructor() {
    this.verifier = null;
    this.initVerifier();
  }

  initVerifier() {
    // Get Cognito configuration from environment variables
    const userPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID;
    const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
    const region = process.env.REACT_APP_COGNITO_REGION;

    if (userPoolId && clientId) {
      this.verifier = CognitoJwtVerifier.create({
        userPoolId,
        tokenUse: "access",
        clientId,
        region: region || "us-east-1", // Default to us-east-1 if not specified
      });
    }
  }

  /**
   * Validates an AWS Cognito token
   * @param {string} token - The authentication token to validate
   * @returns {Promise<boolean>} - True if token is valid, false otherwise
   */
  async validateToken(token) {
    try {
      if (!this.verifier) {
        console.error("Cognito verifier not initialized. Check your environment variables.");
        return false;
      }

      // Verify the token
      const payload = await this.verifier.verify(token);
      return !!payload;
    } catch (error) {
      console.error("Token validation error:", error);
      return false;
    }
  }
}

const cognitoServiceInstance = new CognitoService();
export default cognitoServiceInstance;
